import register from '@kpsys/angularjs-register';
import {KpFooterService} from './kp-footer.service';

export default register('portaro.shared.footer')
    .service(KpFooterService.serviceName, KpFooterService)
    .name();